@if (isMobileOpen$ | async) {
<div
  class="fixed inset-0 z-40 bg-gray-900/50 lg:hidden"
  (click)="closeSidebar()"
></div>
}

